export default __webpack_public_path__ + "static/media/inventory-process.b9cde289.webp";